export let CART:any = { items:[] , customerShippingCost : "", orderId:0 , orderMessage:"", customerOrderNumber:"" , orderTitle:"" , orderStatus:0 ,expectedShipmentDate:"", user:{},odId:0,shippingServiceName:"",shippingServiceId:""};
export let shipmentCART:any = { items:[] ,orderId:0 , orderMessage:"" , orderTitle:"" , orderStatus:0 ,expectedShipmentDate:"", user:{},odId:0,shippingServiceName:"",shippingServiceId:""};
export let RoutingInfo = {dt:"",rt:"", imageBaseUrl:"",billingUrl:"", imageUploaderUrl: "", jazzbaManageUrl:""};
export let AdpCustomer:any = {AdpCustomerInfo:{}};
export let selectedLocationTemorary:any = {location : 0};
export let loginUserInfo = {userName:"", userCountry: "", customerShippingCost : "", productViewType: "", email: "", firstName:"", password:"", lastName:"", phone:"", countryAbbrivation: "", restrictedToViewOrder:0, customerType : "", showInventoryButtonFlag : 0, customPricing : 0,multiCurrencyFlag : 0};
export let supplierInfor = {country:"", uuid:""}
export let Customer = {id:"",paymentCurrency: ""}



export let STOCKCART:any = { items:[] ,orderId:0 , orderMessage:"" , orderTitle:"" , orderStatus:0 ,expectedShipmentDate:"", user:{},odId:0,shippingServiceName:"",shippingServiceId:"", refer:"", location:""};
export let REFERENCE = {productsreference:""};
export let RECEIVESTOCKLOCATION = {productsLocation:""};
export let MOVESTOCKLOCATION = {productsLocation:""};
export let MOVESTOCKCART:any = { items:[] ,orderId:0 , orderMessage:"" , orderTitle:"" , orderStatus:0 ,expectedShipmentDate:"", user:{},odId:0,shippingServiceName:"",shippingServiceId:"", location:""};

export let CATEGORIESnTAGS:any = { categories:[0] , tags: [0] };
export let Theming:any = { selected:"primary" , colorsList:["primary","green","gray","secondary"]};
export let attributesMap :any= {};
export let attributesPropertiesMap :any = new Map();

export let orderListStickyVar = {enteredOrderNumber: "", selectedOrdersType : "-1", selectedSortingType : "Descending"}

export let Messages :any = {
	sessionOutMsg: "You are logged out as someone loggedin from other device.",
	AuthMsg:"Authenticating...",
	LoginSuccessMsg: "",
	LogingErrorMsg:"User not Found.",
	LoginSuccessCustomerMsg:"Customers users can only login through the webstore. Thank you.",
	OrderPlaceSuccessMsg:"Order Placed",
	OrderPlaceFailMsg:"Failed to place Order",
	PasswordRestRequestSuccessMsg:"Password reset request sent successfuly.",
	PasswordChangeSuccessMsg:"Password changed successfuly",
	LoadingMsg:"Loading...",
	WentWrongMsg:"Something Went Wrong...",
	cannotModifySelf: "Cannot modify Self",
	intelliRepUserDeleteConfirm:"Remove seat license and update billing (License will be deleted permanently.)",
	inventoryUpdated: "Inventory is successfully updated!"

	}


	export class CodesDTO {
		id: number;
		abbrivation: string;
		description: string;
		code: string;
		parentId: number;
		status: string;
	}

	export class SignUpDTO {

		companyName: string;
		userName: string;
		password: string;
		email: string;
		phone: string;
		subscriptionPackage: string;
		noOfEmployees: string;
		address: string;
		referal: string;
		country: string;
		customerType: string;
		firstName: string;
		lastName: string;
		codesDTO: CodesDTO;

		constructor(address: string, codesDTO: CodesDTO, companyName: string, country: string, customerType: string, email: string, firstName: string, lastName: string, noOfEmployees: string, password: string, phone: string, referal: string, subscriptionPackage: string, userName: string) {
		this.address = address;
		this.codesDTO = codesDTO;
		this.companyName = companyName;
		this.country = country;
		this.customerType = customerType;
		this.email = email;
		this.firstName = firstName;
		this.lastName = lastName;
		this.noOfEmployees = noOfEmployees;
		this.password = password;
		this.phone = phone;
		this.referal = referal;
		this.userName = userName;
		this.subscriptionPackage = subscriptionPackage;
	  }

	}



// WEBPACK FOOTER //
// ./src/providers/data.ts